<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title>Payments</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        icon
        @click="items=[]; getPayments(status, cboPaymentMethodId, txtPaymentId, txtOrderNo, txtName, txtEmail, txtMinPaymentDate, txtMaxPaymentDate, cboSort); rightDrawer=false;"
      >
        <v-icon>autorenew</v-icon>
      </v-btn>
      <v-btn icon @click.stop="rightDrawer = !rightDrawer" class="white--text">
        <v-icon>filter_list</v-icon>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer
      temporary
      right
      v-model="rightDrawer"
      fixed
      app
      :width=500
    >
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex
            xs12
            text-xs-center
            layout
            align-center
            justify-center
            class="pl-4 pr-4"
          >
            <v-form ref="form" v-model="frmValid" lazy-validation>
              <v-text-field
                v-model="txtPaymentId"
                label="Payment Id"
                @keyup.enter="clickFilter()"
              ></v-text-field>
              <v-text-field
                v-model="txtName"
                label="Name"
                @keyup.enter="clickFilter()"
              ></v-text-field>
              <v-text-field
                v-model="txtEmail"
                label="Email"
                @keyup.enter="clickFilter()"
              ></v-text-field>
              <v-text-field
                v-model="txtOrderNo"
                label="Order No"
                @keyup.enter="clickFilter()"
              ></v-text-field>
              <v-select
                v-model="cboStatus"
                :items="statuses"
                label="Status"
              ></v-select>
              <v-menu
                ref="dtMinPaymentDate"
                :close-on-content-click="false"
                v-model="dtMinPaymentDate"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="txtMinPaymentDate"
                  label="Min Payment Date"
                ></v-text-field>
                <v-date-picker v-model="txtMinPaymentDate" no-title @input="dtMinPaymentDate = false"></v-date-picker>
              </v-menu>
              <v-menu
                ref="dtMaxPaymentDate"
                :close-on-content-click="false"
                v-model="dtMaxPaymentDate"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="txtMaxPaymentDate"
                  label="Max Payment Date"
                ></v-text-field>
                <v-date-picker v-model="txtMaxPaymentDate" no-title @input="dtMaxPaymentDate = false"></v-date-picker>
              </v-menu>
              <v-select
                v-model="cboPaymentMethodId"
                :items="paymentMethods"
                item-text="paymentMethodName"
                item-value="paymentMethodId"
                label="Payment Method"
              ></v-select>
              <v-select
                v-model="cboSort"
                :items="sorts"
                item-text="title"
                item-value="key"
                label="Sorting"
              ></v-select>
              <v-btn
                @click="clickFilter()"
              >
                Filter
              </v-btn>
              <v-btn @click="clearFilter(); getPayments(status, cboPaymentMethodId, txtPaymentId, txtOrderNo, txtName, txtEmail, txtMinPaymentDate, txtMaxPaymentDate, cboSort); rightDrawer=false;">Reset</v-btn>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
    <v-content>
      <v-tabs
        color="grey darken-4"
      >
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          v-for="(item, index) in tabs"
          :key="index"
          :to="'/payments/' + item.key"
        >
          {{ item.title }}
        </v-tab>
      </v-tabs>
      <v-list two-line fill-height>
        <template
          v-for="(item, index) in items">
          <v-list-tile
            :key="item.id"
            avatar
            ripple
            :class="(index % 2 === 0 ? 'row1' : 'row2')"
          >
            <v-list-tile-action>
              <v-list-tile-action-text>
                <v-icon v-if="item.status === 'confirmed'" medium color="green">check_circle_outline</v-icon>
                <v-icon v-else-if="item.status === 'pending'" medium color="white">hourglass_empty</v-icon>
                <v-icon v-else color="red" medium>priority_high</v-icon>
              </v-list-tile-action-text>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>
                <span class="font-weight-bold orange--text text--lighten-2 mr-1">
                  {{ item.title }} {{ item.firstName }} {{ item.lastName }} - {{ item.loginEmail }}
                </span>
                <span v-if="item.salesOrderNos.length > 0" class="mr-2">
                  (<span class="font-weight-bold" v-for="(salesOrder, orderIndex) in item.salesOrderNos" :key="salesOrder.salesOrderNo">
                    <router-link :to="'/order/' + salesOrder.salesOrderNo" class="orange--text text--lighten-2">{{ salesOrder.salesOrderNo }}</router-link>
                    <span v-if="orderIndex < item.salesOrderNos.length - 1" class="ml-0 mr-2">,</span>
                  </span>)
                </span>
                <span class="subheading font-weight-bold">
                  {{ item.currencySign }} {{ formatPrice(item.amount, item.currencyDecimals, item.currencyDecimalSign) }}
                </span>
              </v-list-tile-title>
              <v-list-tile-sub-title>{{ item.createdDateTime | formatDate('DD MMM YYYY HH:mm', profile.gmtTimezone) }}</v-list-tile-sub-title>
              <v-list-tile-sub-title class="text--primary">{{ item.desc }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-list-tile-action-text>
                <v-btn outline small class="mr-2" @click="deletePayment(item.paymentId)">DELETE</v-btn>
                <v-btn outline small v-if="item.status !== 'confirmed'" @click="acceptPayment(item.paymentId)">CONFIRM</v-btn>
                <v-btn outline small v-else @click="cancelPayment(item.paymentId)">CANCEL</v-btn>
                <v-btn outline small class="ml-2" v-if="item.status === 'confirmed'" @click="chargebackPayment(item.paymentId)">Chargeback</v-btn>
              </v-list-tile-action-text>
              <span class="body-2">{{ item.status | capitalize }} <span v-if="item.status === 'confirmed'">on {{ item.confirmationDateTime | formatDate('DD MMM YYYY HH:mm', profile.gmtTimezone) }}</span></span>
            </v-list-tile-action>

            <v-btn icon class="ml-3" color="primary" :to="'/payment/' + item.paymentId">
              <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>

          </v-list-tile>
          <v-divider
            v-if="index + 1 < items.length"
            :key="index"
          ></v-divider>
        </template>
        <template
          v-if="items.length <= 0"
        >
          <v-flex
            xs12
            justify-center
            align-center
            text-xs-center
          >
            <v-icon x-large color="primary">error_outline</v-icon>
            <div>
              No payment yet
            </div>
          </v-flex>
        </template>

      </v-list>

      <v-container fluid grid-list-xs class="mt-3 mb-0">
        <v-layout row wrap>
          <v-flex xs12 class="text-xs-center">
            <div class="mb-3">
              Showing {{ listCountFrom }} - {{ listCountTo }} of {{ listTotal }} orders
            </div>
          </v-flex>
          <v-flex xs12 class="text-xs-center hidden-sm-and-up">
            <v-pagination
              v-model="pageNo"
              :length="(pageCount ? pageCount : 0)"
              :total-visible="5"
              circle
            ></v-pagination>
          </v-flex>
          <v-flex xs12 class="text-xs-center hidden-xs-only">
            <v-pagination
              v-model="pageNo"
              :length="(pageCount ? pageCount : 0)"
              :total-visible="12"
              circle
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-container>

      <v-fab-transition>
        <v-btn
          color=primary
          dark
          fab
          fixed
          bottom
          right
          to="/payment"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
  .media {
    height: 100%;
    margin: 0;
  }

  form {
    width: 100%;
  }

  table.v-table tbody td:first-child {
    padding: 15px 15px;
  }

  .item-name {
    padding: 5px !important;
  }

  .item-thumb {
    width: 60px;
    height: auto;
  }
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import axios from 'axios'
import router from '../router'
import Loading from '@/components/Loading.vue'
// import moment from 'moment'

export default {
  props: {
    status: {
      type: String,
      default: 'pending',
      required: false
    }
  },
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      rightDrawer: false,
      loading: false,
      frmValid: true,
      txtPaymentId: '',
      txtOrderNo: '',
      txtName: '',
      txtEmail: '',
      dtMinPaymentDate: false,
      dtMaxPaymentDate: false,
      txtMinPaymentDate: '',
      txtMaxPaymentDate: '',
      cboPaymentMethodId: '',
      paymentMethods: [],
      cboStatus: '',
      statuses: ['all', 'pending', 'confirmed', 'rejected', 'chargeback'],
      cboSort: '',
      sorts: [
        {
          key: 'createdDateTime:desc',
          title: 'Latest'
        },
        {
          key: 'createdDateTime:asc',
          title: 'From beginning'
        }
      ],
      isLoadingItems: false,
      items: [],
      listLimit: 15,
      listOffset: 0,
      listTotal: 0,
      listCountFrom: 0,
      listCountTo: this.listLimit,
      pageNo: parseInt(this.$route.query.pg) || 1,
      pageCount: 0,
      tabs: [
        {
          key: 'pending',
          title: 'Pending'
        },
        {
          key: 'confirmed',
          title: 'Confirmed'
        },
        {
          key: 'chargeback',
          title: 'Chargeback'
        },
        {
          key: 'all',
          title: 'All'
        }
      ]
    }
  },

  mounted () {
    this.openDrawerForDesktop()

    // init
    this.clearFilter()
    this.cboPaymentMethodId = this.$route.query.method || ''
    this.txtPaymentId = this.$route.query.payment_id || ''
    this.txtOrderNo = this.$route.query.order_no || ''
    this.txtEmail = this.$route.query.email || ''
    this.txtName = this.$route.query.name || ''
    this.txtMinPaymentDate = this.$route.query.min_date || ''
    this.txtMaxPaymentDate = this.$route.query.max_date || ''
    this.cboSort = this.$route.query.sort || ''

    this.getPayments(this.status, this.cboPaymentMethodId, this.txtPaymentId, this.txtOrderNo, this.txtName, this.txtEmail, this.txtMinPaymentDate, this.txtMaxPaymentDate, this.cboSort)
    this.listPaymentMethods()
  },
  watch: {
    pageNo (val, oldVal) {
      // If page no changes, navigate to new page
      this.getPayments(this.status, this.cboPaymentMethodId, this.txtPaymentId, this.txtOrderNo, this.txtName, this.txtEmail, this.txtMinPaymentDate, this.txtMaxPaymentDate, this.cboSort, (val - 1) * this.listLimit)
    }
  },
  methods: {
    clickFilter: function () {
      this.items = []
      this.rightDrawer = false
      if (this.cboStatus === this.status) {
        this.getPayments(this.status, this.cboPaymentMethodId, this.txtPaymentId, this.txtOrderNo, this.txtName, this.txtEmail, this.txtMinPaymentDate, this.txtMaxPaymentDate, this.cboSort)
      } else {
        router.push('/payments/' + this.cboStatus + '?&method=' + this.cboPaymentMethodId + '&order_no=' + this.txtOrderNo + '&name=' + this.txtName + '&email=' + this.txtEmail + '&min_date=' + this.txtMinPaymentDate + '&max_date=' + this.txtMaxPaymentDate + '&sort=' + this.cboSort)
      }
    },
    listPaymentMethods: function () {
      var url = process.env.VUE_APP_API_ROOT + '/v1/payment/methods'
      var _this = this
      axios.get(url)
        .then(resp => {
          if (resp.data.status === 'success') {
            _this.paymentMethods = resp.data.data
          } else {
            console.log('unable to list payment methods: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              clearInterval(_this.autoloadInterval)
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              clearInterval(_this.autoloadInterval)
              console.log(error.response)
            }
            _this.loading = false
          }
        })
    },
    getPayments: function (status = '', paymentMethodId = '', paymentId = '', orderNo = '', name = '', email = '', minCreatedDate = '', maxCreatedDate = '', sort = '', offset = 0) {
      var _this = this
      if (_this.isLoadingItems === false) {
        var params = ''
        _this.isLoadingItems = true
        _this.loading = true
        if (status === 'all') {
          status = ''
        }
        params += 'status=' + status + '&payment_method_id=' + paymentMethodId + '&payment_id=' + paymentId + '&sales_order_no=' + orderNo + '&name=' + name + '&login_email=' + email + '&min_created_datetime=' + minCreatedDate + '&max_created_datetime=' + maxCreatedDate + '&sort=' + sort + '&limit=' + _this.listLimit + '&offset=' + offset
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/payments?' + params)
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.items = []
              for (var c = 0; c < resp.data.data.length; ++c) {
                resp.data.data[c].desc = resp.data.data[c].paymentMethodName
                if (resp.data.data[c].paymentMethodId.substr(0, 12) === 'BANKTRANSFER') {
                  resp.data.data[c].desc += ' - ' + resp.data.data[c].ttDestinationBankName + ' - ' + resp.data.data[c].ttDestinationBankAccountNo + ' - ' + resp.data.data[c].ttDestinationBankAccountName
                } else if (resp.data.data[c].paymentMethodId === 'CASH') {
                  resp.data.data[c].desc += ' - Received by ' + resp.data.data[c].cashReceivedBy
                }
              }
              _this.items = resp.data.data
              _this.listLimit = resp.data.limit
              _this.listOffset = resp.data.offset
              _this.listTotal = resp.data.total
              _this.pageCount = Math.ceil(_this.listTotal / _this.listLimit)
              _this.listCountFrom = _this.listOffset + 1
              _this.listCountTo = (_this.listCountFrom - 1) + _this.items.length
              if (_this.items.length === 0) {
                _this.listCountFrom = 0
                _this.listCountTo = 0
              }
            } else {
              console.log('unable to load payments: ' + resp.data.message)
            }
            _this.isLoadingItems = false
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              }
              _this.loading = false
            }
          })
      }
    },
    acceptPayment: function (paymentId) {
      this.loading = true
      var _this = this
      axios.put(process.env.VUE_APP_API_ROOT + '/v1/payment/' + paymentId, {
        status: 'confirmed'
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(resp => {
          if (resp.data.status === 'success') {
            _this.loading = false
            _this.getPayments(_this.status, _this.cboPaymentMethodId, _this.txtPaymentId, _this.txtOrderNo, _this.txtName, _this.txtEmail, _this.txtMinPaymentDate, _this.txtMaxPaymentDate, _this.cboSort, (_this.pageNo - 1) * _this.listLimit)
            window.alert('Payment confirmed')
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    cancelPayment: function (paymentId) {
      this.loading = true
      var _this = this
      axios.put(process.env.VUE_APP_API_ROOT + '/v1/payment/' + paymentId, {
        status: 'pending'
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(resp => {
          if (resp.data.status === 'success') {
            _this.loading = false
            _this.getPayments(_this.status, _this.cboPaymentMethodId, _this.txtPaymentId, _this.txtOrderNo, _this.txtName, _this.txtEmail, _this.txtMinPaymentDate, _this.txtMaxPaymentDate, _this.cboSort, (_this.pageNo - 1) * _this.listLimit)
            window.alert('Payment canceled')
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    deletePayment: function (paymentId) {
      var action = window.confirm('Are you sure to delete this payment?')
      if (action) {
        this.loading = true
        var _this = this
        axios.delete(process.env.VUE_APP_API_ROOT + '/v1/payment/' + paymentId)
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.getPayments(_this.status, _this.cboPaymentMethodId, _this.txtPaymentId, _this.txtOrderNo, _this.txtName, _this.txtEmail, _this.txtMinPaymentDate, _this.txtMaxPaymentDate, _this.cboSort, (_this.pageNo - 1) * _this.listLimit)
            } else {
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      }
    },
    chargebackPayment: function (paymentId) {
      this.loading = true
      var _this = this
      axios.put(process.env.VUE_APP_API_ROOT + '/v1/payment/' + paymentId, {
        status: 'chargeback'
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(resp => {
          if (resp.data.status === 'success') {
            _this.loading = false
            _this.getPayments(_this.status, _this.cboPaymentMethodId, _this.txtPaymentId, _this.txtOrderNo, _this.txtName, _this.txtEmail, _this.txtMinPaymentDate, _this.txtMaxPaymentDate, _this.cboSort, (_this.pageNo - 1) * _this.listLimit)
            window.alert('Payment set as chargeback')
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    clearFilter () {
      this.cboStatus = this.status
      if (typeof this.cboStatus === 'undefined' || this.cboStatus === '') {
        this.cboStatus = 'pending'
      }
      this.cboPaymentMethodId = ''
      this.txtPaymentId = ''
      this.txtOrderNo = ''
      this.txtEmail = ''
      this.txtName = ''
      this.txtMinPaymentDate = ''
      this.txtMaxPaymentDate = ''
      this.cboSort = ''
      this.items = []
      this.listOffset = 0
      this.listTotal = 0
      this.pageCount = 1
      this.listCountFrom = 0
      this.listCountTo = 0
      this.pageNo = 1
      this.rightDrawer = false
    }
  }
}
</script>
